module.exports = __webpack_public_path__ + "media/images/icons/outlined/border-verticle-c04197e83354b001d91e4bdc6dd8be75.svg";